module.exports = __webpack_public_path__ + "img/error-form.c11329ed.svg";